import React, {Component} from 'react';
import {findDOMNode} from 'react-dom'

import {connect} from 'react-redux'
import {push as routerPush} from 'react-router-redux'
import * as productSearchActions from '../actions/productSearchActions'

import {locale} from "../locale/AppLocale";
import {
    Link, Navigate
} from 'react-router-dom'
import {NotificationManager} from '../Helpers/NotificationManager';

;
import {Tooltip as ReactTooltip} from 'react-tooltip'

class SearchInput extends Component {

    constructor(props) {
        super(props);
        this.fetchCategoriesByKeyword = this.fetchCategoriesByKeyword.bind(this);
        this.canSearch = this.canSearch.bind(this);
        this.state = {
            isToolTipOpened: true,
            doSearch: false,
            navigateSearchTo: false,
        }
    }

    componentDidMount() {
        // window._ReactTooltip = ReactTooltip;
        // ReactTooltip.show(findDOMNode(this.refs.tooltip_search))
    }

    canSearch() {
        return this.props.productSearch.keyword.length >= 3;
    }

    render() {
        // if (this.state.doSearch) {
        //     return <Navigate
        //         to={{pathname: `/${this.props.match.params.businessSlug}/search/k/` + encodeURIComponent(this.props.productSearch.keyword)}}/>;
        // }
        return (
            this.isCategorySearch() === false && <div className="product-search--form">

                <form className="search-form" onSubmit={this.onSubmit.bind(this)}>

                    {/*<div className="tooltip-field" data-scroll-hide={true} data-event="focusout"*/}
                    {/*     data-event-off=" click focusin keyup" data-tip='' data-for='tooltip-input-search-form'*/}

                    {/*     data-place="top" data-html="true" data-iscapture="false" data-effect="solid"*/}
                    {/*     data-multiline="true">*/}
                    {/*    <input type="text"*/}
                    {/*           data-tooltip-id="tooltip-input-search-form"*/}

                    {/*           value={this.props.productSearch.keyword}*/}
                    {/*           onChange={this.onChange.bind(this)}*/}
                    {/*           className="input-search-form"*/}
                    {/*           autoFocus={false}*/}
                    {/*           placeholder={locale.get('search_placeholder')}*/}
                    {/*           onFocus={e => this.setState({isToolTipOpened: false})}*/}
                    {/*           onBlur={e => this.setState({isToolTipOpened: true})}*/}
                    {/*    />*/}

                    {/*    <ReactTooltip*/}
                    {/*        isOpen={this.state.isToolTipOpened}*/}
                    {/*        id='tooltip-input-search-form'>{locale.get('tooltip_search_hint')}</ReactTooltip>*/}
                    {/*</div>*/}

                    {/*{this.isCategorySearch() ? (*/}

                    {/*    <button className="btn-1">{locale.get('search')}</button>*/}

                    {/*) : (<button className="btn-1"*/}
                    {/*             disabled={this.props.productSearch.keyword.length < 3}>{locale.get('search')}</button>)}*/}

                    {this.isCategorySearch() ? ((<Link className="btn-2"
                                                       to={`/${this.props.match.params.businessSlug}/search`}>{locale.get('all_categories')}</Link>)) : (
                        <Link className="btn-2"
                              to={`/${this.props.match.params.businessSlug}/search/categories`}>{locale.get('categories')}</Link>)}

                </form>

                {(
                        this.props.location.pathname === `/${this.props.match.params.businessSlug}/search` ||
                        this.props.location.pathname === `/${this.props.match.params.businessSlug}/search/`
                    ) &&
                    <div className="products-bulk-upload">
                        <h1>{locale.get('product_bulk_upload_heading')}</h1>
                        {
                            /*
                             <p>{locale.get('product_bulk_upload_desc_2')} <a href="mailto:info@shooq.co.il" target="_blank">info@shooq.co.il</a></p>
                             <p>{locale.get('product_bulk_upload_desc')}</p>
                             */
                        }
                        <Link to={`/${this.props.match.params.businessSlug}/upload`}>
                            <button className="btn-2">{locale.get('product_bulk_upload_button')}</button>
                        </Link>
                    </div>
                }

            </div>
        );
    }

    fetchCategoriesByKeyword() {
        this.props.updateKeyword('');
    }

    isCategorySearch() {
        return this.props.location.pathname.indexOf(`/${this.props.match.params.businessSlug}/search/categories`) > -1;
    }

    onSubmit(e) {
        e.preventDefault();
        if (!this.canSearch()) {
            NotificationManager.error(locale.get('minimum_characters_to_search'));
            return false;
        }

        this.props.searchCategories(this.props.productSearch.keyword);
        this.setState({
            doSearch: true,
        })
    }

    onChange(e) {
        this.props.updateKeyword(e.target.value);
    }
}

// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth,
        productSearch: state.productSearch,
        findCategoryProducts: state.findCategoryProducts,
    }
};


// Maps actions to props
const mapDispatchToProps = (dispatch, props) => {
    return {
        updateKeyword: (keyword) => dispatch(productSearchActions.updateKeyword(keyword)),
        searchCategories: (keyword) => {
            // dispatch(routerPush(`/${props.match.params.businessSlug}/search/k/` + encodeURIComponent(keyword)));
            // dispatch(productSearchActions.fetchCategoriesByKeyword(keyword));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchInput);